import Vue, { VueConstructor } from 'vue';
import { gameStore } from '@/store/game/store';
import { JustoneClient } from '@/client';
import { Action } from '@/actions';

export default (Vue as VueConstructor<Vue & {
    $refs: {
        gameLink: HTMLInputElement
    };
}>).extend({
    data() {
        return {
            interval: undefined as undefined | NodeJS.Timeout,
            nextDelay: 60
        }
    },
    computed: {
        nextTurnClicked(): boolean {
            return !!this.interval;
        },
        showHints(): boolean {
            return gameStore.state.players.length - 1 == gameStore.state.currentTurn.playersWhoAddedHints.length;
        },
    },
    methods: {
        nextTurn() {
            const client = JustoneClient.getInstance();
            if (this.nextTurnClicked) {
                clearInterval(this.interval!);
                this.nextDelay = 60;
                client.send({
                    action: Action.nextTurn
                });
                return;
            }
            client.send({
                action: Action.getAllHints
            })
            this.interval = setInterval(() => {
                this.nextDelay--;
            }, 1000);
        },
    },
    watch: {
        nextDelay() {
            if (this.nextDelay == 0) {
                this.nextTurn();
            }
        }
    }
});